/* FUSIFY categoriepagina's. Alle kaarten, filters en teksten staan al server-side in de HTML (sections/fzk-collectie.liquid).
   Dit script filtert, sorteert en voegt toe aan de winkelwagen; het maakt geen inhoud aan die Google moet zien.
   Bron: collectiepagina/bouw/fzk-collectie.js (concept: staging/col.js) */
(function () {
  var root = document.getElementById('fzk'), cfgEl = document.getElementById('fzk-cfg');
  if (!root || !cfgEl) return;
  var C = JSON.parse(cfgEl.textContent), pagina = C.pagina;
  document.body.classList.add('fzk-on', 'fzk-p-' + pagina);

  /* ---------- hulpjes ---------- */
  var ICO = {
    pijl: '<path d="M5 12h14M13 6l6 6-6 6"/>', kruis: '<path d="M6 6l12 12M18 6L6 18"/>'
  };
  var ico = function (n, s) { return '<svg viewBox="0 0 24 24" width="' + (s || 20) + '" height="' + (s || 20) + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICO[n] + '</svg>' };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] }) };
  var ga = function (naam, p) {
    try { if (typeof window.gtag === 'function') { p = p || {}; p.fzk_pagina = pagina; window.gtag('event', naam, p) } } catch (e) { }
  };
  var toast = function (t) {
    var d = document.createElement('div'); d.className = 'fzk-toast'; d.setAttribute('role', 'status'); d.textContent = t; document.body.appendChild(d);
    setTimeout(function () { d.classList.add('in') }, 10); setTimeout(function () { d.classList.remove('in'); setTimeout(function () { d.remove() }, 300) }, 2600);
  };

  /* ---------- in winkelwagen (geurpods) ---------- */
  root.addEventListener('click', function (e) {
    var k = e.target.closest('[data-add]'); if (!k) return;
    e.preventDefault(); if (k.classList.contains('bezig')) return;
    k.classList.add('bezig');
    var naam = k.getAttribute('data-add-naam') || '';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +k.getAttribute('data-add'), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json() }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      toast('✓ ' + naam + ' toegevoegd aan je winkelwagen');
      ga('fzk_in_winkelwagen', { item_name: naam });
    }).catch(function () { toast('Dat lukte niet. Probeer het opnieuw.') }).then(function () { k.classList.remove('bezig') });
  });

  /* ---------- kaarten uit de HTML ---------- */
  var raster = root.querySelector('.fzk-raster');
  var items = raster ? [].slice.call(raster.querySelectorAll(':scope > .fzk-pk')).map(function (el, i) {
    var f = {}; try { f = JSON.parse(el.getAttribute('data-f') || '{}') } catch (e) { }
    if (!f || typeof f !== 'object') f = {};
    var ds = el.dataset;
    f.cat = [ds.cat]; f.prijs = [ds.prijsk]; if (ds.maat) f.maat = [ds.maat]; if (!f.voor) f.voor = ['thuis'];
    return { el: el, f: f, prijs: +ds.prijs || 0, bes: +ds.bes || 0, r: +ds.r || 0, n: +ds.n || 0, naam: ds.naam || '', badge: ds.badge === '1', int: +ds.int || 2,
      zak: ds.zak === '1', rang: +ds.rang || 9, volg: i, maat: ds.maat, fam: ds.fam, profiel: ds.profiel,
      url: (el.querySelector('a') || {}).href, img: ((el.querySelector('img') || {}).currentSrc || (el.querySelector('img') || {}).src || '') };
  }) : [];

  /* sets: grootste besparing eerst (zoals in het concept) */
  if (pagina === 'bundels' && raster) items.slice().sort(function (a, b) { return b.bes - a.bes }).forEach(function (p) { raster.appendChild(p.el) });

  /* ---------- filter-engine (zelfde op elke pagina, andere opties) ---------- */
  var SORT = {
    populair: pagina === 'geurpods' ? function (a, b) { return (b.badge ? 1 : 0) - (a.badge ? 1 : 0) || b.n - a.n || a.volg - b.volg }
      : pagina === 'diffusers' ? function (a, b) { return (a.zak ? 1 : 0) - (b.zak ? 1 : 0) || (b.badge ? 1 : 0) - (a.badge ? 1 : 0) || b.n - a.n || a.volg - b.volg }
        : function (a, b) { return a.rang - b.rang || a.volg - b.volg },
    beoordeeld: function (a, b) { return b.r - a.r || b.n - a.n },
    zacht: function (a, b) { return a.int - b.int || a.volg - b.volg },
    az: function (a, b) { return a.naam.localeCompare(b.naam, 'nl') },
    'prijs-op': function (a, b) { return a.prijs - b.prijs },
    'prijs-af': function (a, b) { return b.prijs - a.prijs }
  };
  var w = null;
  if (C.groepen && raster) w = winkel();

  function winkel() {
    var groepen = C.groepen, per = C.perPagina || 0, toon = per || 9999, st = { sort: 'populair' };
    groepen.forEach(function (g) { st[g[0]] = ((C.start || {})[g[0]] || []).slice() });
    var label = {}; groepen.forEach(function (g) { label[g[0]] = g[2] });
    var leeg = root.querySelector('.fzk-leeg'), meer = root.querySelector('.fzk-meer');
    function past(p, zonder) { return groepen.every(function (g) { var k = g[0]; return k === zonder || !st[k].length || st[k].some(function (v) { return (p.f[k] || []).indexOf(v) > -1 }) }) }
    function teken() {
      var lijst = items.filter(function (p) { return past(p) }).sort(SORT[st.sort] || SORT.populair);
      var zicht = {};
      lijst.forEach(function (p, i) { raster.appendChild(p.el); p.el.hidden = i >= toon; zicht[p.volg] = 1 });
      items.forEach(function (p) { if (!zicht[p.volg]) { p.el.hidden = true; raster.appendChild(p.el) } });
      leeg.hidden = !!lijst.length;
      var rest = lijst.length - toon;
      meer.innerHTML = rest > 0 ? '<p>Je bekijkt ' + toon + ' van ' + lijst.length + ' ' + C.eenheid[1] + '</p><button type="button" class="fzk-knop fzk-knop--licht" data-meer>Toon meer (' + Math.min(rest, per) + ')</button>' : '';
      var act = []; groepen.forEach(function (g) { st[g[0]].forEach(function (v) { act.push([g[0], v, label[g[0]][v] || v]) }) });
      root.querySelector('.fzk-balk__n').innerHTML = '<b>' + lijst.length + '</b> ' + (lijst.length === 1 ? C.eenheid[0] : C.eenheid[1]);
      [].forEach.call(document.querySelectorAll('.fzk-telf'), function (x) { x.textContent = act.length ? '(' + act.length + ')' : '' });
      root.querySelector('.fzk-telk').textContent = lijst.length;
      root.querySelector('.fzk-actief').innerHTML = act.map(function (a) { return '<button type="button" data-weg="' + esc(a[0] + ':' + a[1]) + '">' + esc(a[2]) + ico('kruis', 14) + '</button>' }).join('') +
        (act.length ? '<button type="button" class="fzk-actief__wis" data-reset>Wis alles</button>' : '');
      [].forEach.call(root.querySelectorAll('[data-f]'), function (c) {
        if (c.tagName !== 'INPUT') return;
        var k = c.getAttribute('data-f'), m = items.filter(function (p) { return (p.f[k] || []).indexOf(c.value) > -1 && past(p, k) }).length;
        c.checked = st[k].indexOf(c.value) > -1; c.parentNode.querySelector('em').textContent = m; c.parentNode.classList.toggle('nul', !m && !c.checked);
      });
    }
    function zetSort(v) {
      st.sort = v;
      [].forEach.call(root.querySelectorAll('[data-sort]'), function (x) { if (x.tagName === 'SELECT') x.value = v; else x.checked = x.value === v });
    }
    root.addEventListener('change', function (e) {
      var c = e.target;
      if (c.matches('input[data-f]')) {
        var k = c.getAttribute('data-f'), a = st[k], i = a.indexOf(c.value);
        if (c.checked && i < 0) a.push(c.value); if (!c.checked && i > -1) a.splice(i, 1);
        toon = per || 9999; teken();
        ga('fzk_filter', { filter_groep: k, filter_waarde: c.value, filter_actie: c.checked ? 'aan' : 'uit' });
      }
      if (c.matches('[data-sort]')) { zetSort(c.value); teken(); ga('fzk_sorteer', { sortering: c.value }) }
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      if (t.hasAttribute('data-weg')) { var p = t.getAttribute('data-weg').split(':'), a = st[p[0]], i = a.indexOf(p[1]); if (i > -1) a.splice(i, 1); teken() }
      if (t.hasAttribute('data-reset')) { groepen.forEach(function (g) { st[g[0]] = [] }); toon = per || 9999; teken(); ga('fzk_filter_wissen') }
      if (t.hasAttribute('data-meer')) { toon += per; teken(); ga('fzk_toon_meer', { getoond: toon }) }
    });
    /* filterpaneel open/dicht (de zwevende knop staat buiten #fzk) */
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-open-filter],[data-sluit-filter]');
      if (t && t.hasAttribute('data-open-filter')) { document.body.classList.add('fzk-filter-open'); return }
      if (t && t.hasAttribute('data-sluit-filter')) { document.body.classList.remove('fzk-filter-open'); return }
      /* tik naast het paneel = sluiten */
      if (document.body.classList.contains('fzk-filter-open') && !e.target.closest('.fzk-filters')) document.body.classList.remove('fzk-filter-open');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.body.classList.remove('fzk-filter-open') });
    /* zwevende filterknop: zichtbaar als de werkbalk uit beeld is en het raster in beeld */
    var zw = root.querySelector('.fzk-zweef'), balk = root.querySelector('.fzk-balk'), win = root.querySelector('.fzk-winkel');
    if (zw && 'IntersectionObserver' in window) {
      var balkZicht = true, rasterZicht = false, zet = function () { zw.classList.toggle('in', !balkZicht && rasterZicht) };
      new IntersectionObserver(function (e) { balkZicht = e[0].isIntersecting; zet() }).observe(balk);
      new IntersectionObserver(function (e) { rasterZicht = e[0].isIntersecting; zet() }, { rootMargin: '0px 0px -40% 0px' }).observe(win);
    }
    teken();
    return { zet: function (k, v) { st[k] = v.slice(); toon = per || 9999; teken() } };
  }

  /* ---------- geurtest (geurpods): 3 vragen, advies uit de kaarten van deze maat ---------- */
  if (pagina === 'geurpods' && C.test) {
    root.addEventListener('click', function (e) { if (e.target.closest('[data-test]')) { e.preventDefault(); geurtest() } });
  }
  function geurtest() {
    var T = C.test, V = [['ruimte', 'Waar wil je de geur ruiken?', T.ruimte], ['gevoel', 'Welk gevoel wil je oproepen?', T.gevoel], ['lijkt', 'Van welke geur word je blij?', T.lijkt]], ant = {}, stap = 0;
    var pods = items.filter(function (p) { return p.maat === C.maat });
    var m = document.createElement('div'); m.className = 'fzk-test'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Geurtest');
    document.body.appendChild(m); document.body.classList.add('fzk-test-open');
    ga('fzk_geurtest_start');
    function sluit() { m.remove(); document.body.classList.remove('fzk-test-open'); document.removeEventListener('keydown', escTest) }
    function escTest(e) { if (e.key === 'Escape') sluit() }
    document.addEventListener('keydown', escTest);
    function kop(t) { return '<div class="fzk-test__kop"><span>' + t + '</span><button type="button" data-x aria-label="Sluiten">' + ico('kruis') + '</button></div>' }
    function vraag() {
      var q = V[stap];
      m.innerHTML = '<div class="fzk-test__in">' + kop('Vraag ' + (stap + 1) + ' van 3') +
        '<div class="fzk-test__bar"><i style="width:' + (stap / 3 * 100) + '%"></i></div><h2>' + q[1] + '</h2><div class="fzk-test__o">' +
        Object.keys(q[2]).map(function (k) { return '<button type="button" data-a="' + k + '">' + esc(q[2][k]) + '</button>' }).join('') + '</div>' +
        (stap ? '<button type="button" class="fzk-test__terug" data-terug>← Vorige vraag</button>' : '') + '</div>';
    }
    function uitslag() {
      var sc = pods.map(function (p) {
        return { p: p, s: ((p.f.ruimte || []).indexOf(ant.ruimte) > -1 ? 3 : 0) + ((p.f.gevoel || []).indexOf(ant.gevoel) > -1 ? 4 : 0) + ((p.f.lijkt || []).indexOf(ant.lijkt) > -1 ? 3 : 0) + (p.n ? p.r / 10 : 0) };
      }).sort(function (a, b) { return b.s - a.s }).slice(0, 3);
      m.innerHTML = '<div class="fzk-test__in">' + kop('Jouw geuradvies') + '<div class="fzk-test__bar"><i style="width:100%"></i></div>' +
        '<h2>Deze geuren passen bij jou</h2><p class="fzk-test__sub">Voor je ' + esc(T.ruimte[ant.ruimte].toLowerCase()) + ', ' + esc(T.gevoel[ant.gevoel].toLowerCase()) + ', met een vleugje ' + esc(T.lijkt[ant.lijkt].toLowerCase()) + '.</p>' +
        '<div class="fzk-test__res">' + sc.map(function (x, i) {
          var p = x.p, pct = Math.min(98, Math.round(55 + x.s / 10.5 * 43));
          return '<a class="fzk-test__g' + (i ? '' : ' eerste') + '" href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt=""><span><em>' + pct + '% match</em><b>' + esc(p.naam) + '</b><small>' + esc(p.profiel) + (T.fam[p.fam] ? ' · ' + esc(T.fam[p.fam]) : '') + '</small></span>' + ico('pijl') + '</a>' }).join('') + '</div>' +
        '<div class="fzk-test__voet"><button type="button" class="fzk-knop" data-toepassen>Toon alle passende geuren</button><a class="fzk-knop fzk-knop--licht" href="/products/all-in-1-sample-kit">Liever eerst ruiken? Sample kit</a></div></div>';
      ga('fzk_geurtest_uitslag', { ruimte: ant.ruimte, gevoel: ant.gevoel, lijkt: ant.lijkt, advies: sc.length ? sc[0].p.naam : '' });
    }
    vraag();
    m.addEventListener('click', function (e) {
      if (e.target === m) return sluit();
      var t = e.target.closest('button,a'); if (!t) return;
      if (t.hasAttribute('data-x')) return sluit();
      if (t.hasAttribute('data-terug')) { stap--; return vraag() }
      if (t.hasAttribute('data-a')) { ant[V[stap][0]] = t.getAttribute('data-a'); stap++; return stap < 3 ? vraag() : uitslag() }
      if (t.hasAttribute('data-toepassen') && w) {
        w.zet('ruimte', [ant.ruimte]); w.zet('gevoel', [ant.gevoel]); sluit();
        var doel = document.getElementById('fzk-winkel'); if (doel) doel.scrollIntoView({ behavior: 'smooth' });
      }
      if (t.tagName === 'A') ga('fzk_geurtest_klik', { link: t.getAttribute('href') });
    });
  }
})();
